import { Form, Col, Row, Checkbox } from "antd";
import { FormInstance } from "antd/lib/form/Form";
import Title from "antd/lib/typography/Title";
import React from "react";
import { DataGrid } from "@core-ui/datagrid";
import FormLabel from "../../../core/ui/components/FormLabel";
import { TOrganisationIndexGroupPresentationModel } from "../../presenter/model/OrganisationIndexGroupPresentationModel";
import { IOrganisationIndexGroup } from "../../model/OrganisationIndexGroup";

interface OrganisationIndexGroupConnectionFormProps {
  translate: any;
  referenceLoader?: boolean;
  groups: TOrganisationIndexGroupPresentationModel[];
  toggleConnected: any;
  form: FormInstance;
  createOrganisationIndexGroup?: any;
  clickedGroup?: IOrganisationIndexGroup;
  searchGroupFunction: any;
  toggleGroupFilterByParentName: any;
}
const OrganisationIndexGroupConnectionForm: React.FC<OrganisationIndexGroupConnectionFormProps> =
  ({
    translate,
    groups,
    toggleConnected,
    form,
    createOrganisationIndexGroup,
    clickedGroup,
    searchGroupFunction,
    toggleGroupFilterByParentName
  }) => {
    const changeConnected = (index, e) => {
      toggleConnected(index, e.target.checked);
    };

    const columns = [
      {
        title: translate("editors.organisation_index_groups.name"),
        key: "name",
        dataIndex: ["name"]
      },
      {
        title: translate("editors.organisation_index_groups.organisation"),
        key: "organisation",
        dataIndex: ["organisation", "name"]
      },
      {
        title: translate("editors.organisation_index_groups.type"),
        key: "groupType",
        dataIndex: ["indexType", "name"]
      },
      {
        title: translate("editors.organisation_index_groups.connect"),
        key: "connect",
        render: (record) => (
          <Checkbox
            style={{ margin: "0.5em" }}
            onChange={(e) => changeConnected(record, e)}
          />
        )
      }
    ];

    return (
      <Form form={form}>
        <Row className={"datagrid-header"}>
          <Col lg={18} sm={13}>
            <Title level={1} className={"datagrid-title"}>
              {translate("editors.organisation_index_groups.title")}
            </Title>
          </Col>
        </Row>
        <Row>
          <div style={{ marginTop: "1em", marginBottom: "2.5em" }}>
            {translate("editors.organisation_index_groups.connect_message")}
          </div>
        </Row>
        <Row>
          <div style={{ marginBottom: "1em", display: "flex" }}>
            <FormLabel
              text={translate(
                "editors.organisation_index_groups.filter_by_parent_name"
              )}
            />
            <Checkbox
              style={{ marginLeft: "1em" }}
              onChange={(e) => toggleGroupFilterByParentName(e.target.checked)}
            />
          </div>
        </Row>
        <Row>
          <Col span={24}>
            <DataGrid
              tableFormManager={{
                columns: columns,
                dataSource: groups,
                keyProperty: "id",
                locale: {},
                childrenColumnName: "",
                singleRowExpandEnabled: false,
                customExpandIcon: () => null
              }}
              headerFormManager={{ title: "" }}
              searchFormManager={{
                searchEnabled: true,
                searchTablePlaceholder: translate(
                  "editors.organisation_index_groups.search_label"
                ),
                searchFunction: searchGroupFunction
              }}
              pagingFormManager={{
                dataSource: groups,
                itemsPerPageLabel: "",
                showingLabel: translate(
                  "editors.organisation_index_groups.showing_label"
                ),
                totalLabel: translate(
                  "editors.organisation_index_groups.total_label"
                ),
                toLabel: translate(
                  "editors.organisation_index_groups.to_label"
                ),
                pageSize: 10
              }}
              deleteModalFormManager={{}}
              createModalFormManager={{}}
              updateModalFormManager={{}}
            />
          </Col>
        </Row>
      </Form>
    );
  };
export default OrganisationIndexGroupConnectionForm;
